import React from 'react'

import './styles.scss'

const baseClass = 'dashboard-commits-loader'

const CompanyDashboardCommitsLoader = () => (
  <div className={`company-dashboard-commits`}>
    <div
      className="loader-row"
      style={{
        height: '20px',
        width: '58px',
        marginBottom: '20px',
      }}
    />
    <div className={`company-dashboard-commits__commits-section`}>
      <div className={`company-dashboard-commits__commits-icon ${baseClass}__circle`} />
      <div className={`company-dashboard-commits__commits-info`}>
        <div
          className="loader-row"
          style={{
            height: '31px',
            width: '60px',
            marginBottom: '2px',
          }}
        />
        <div
          className="loader-row"
          style={{
            height: '15px',
            width: '30px',
          }}
        />
      </div>
    </div>
    <div className={`company-dashboard-commits__commits-section`}>
      <div className={`company-dashboard-commits__commits-icon ${baseClass}__circle`} />
      <div className={`company-dashboard-commits__commits-info`}>
        <div
          className="loader-row"
          style={{
            height: '31px',
            width: '60px',
            marginBottom: '2px',
          }}
        />
        <div
          className="loader-row"
          style={{
            height: '15px',
            width: '30px',
          }}
        />
      </div>
    </div>
  </div>
)

export default CompanyDashboardCommitsLoader
